export class AppMessageConstant{
  static unknown_error = 'Có lỗi lấy dữ liệu từ server';
  static get_config_error = 'Không lấy được cấu hình từ server, vui lòng thông báo admin';
  static delete_success = 'Xóa thành công';
  static approve_success = 'Duyệt thành công';
  static undo_approve_success = 'Bỏ duyệt thành công';
  static confirm_success = 'Xác nhận thành công';
  static undo_confirm_success = 'Bỏ xác nhận thành công';
  static insert_success = 'Tạo mới thành công';
  static update_success = 'Cập nhật thành công';
  static lock_success = 'Đánh dấu xóa thành công';
  static un_lock_success = 'Phục hồi thành công';
  static complete_success = 'Hoàn tất thành công';
  static uncomplete_success = 'Bỏ hoàn tất thành công';
  static send_email_success = 'Gởi email thành công';
  static id_not_empty = 'Mã không được bỏ trống';
  static no_record_found = 'Không tìm thấy dữ liệu';
  static request_selecting_row = 'Vui lòng chọn chỉ một dòng';
  static request_selecting_rows = 'Vui lòng chọn ít nhất một dòng';
  static no_data_message = 'Không có dữ liệu';
  static deleteWaringDialog(id: string)
  {return { title: 'Cảnh báo', content: 'Bạn có thật sự muốn xóa ' + id + ' không?', isOK: false } }
}
